import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ISitePages } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { FileUpload } from "primereact/fileupload";

const schema = yup.object({
    page: yup.string().required("Page is required*"),
    title: yup.string().required("Title is required*"),
    description: yup.string().required("Description is required*"),
    keywords: yup.string().required("Keywords is required*"),
    imageHeight: yup.string().required("Image Height is required*"),
    imageWidth: yup.string().required("Image Width is required*"),
    imageType: yup.string().required("Image Type is required*"),

});

interface Iprops {
    singleData: ISitePages,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [submitting, setSubmitting] = useState(false);
    const [imageType, setImageType] = useState<string>("");
    const [image, setImage] = useState(false);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<ISitePages>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);


    const onHide = () => {
        props.hideDialog();
        reset({});
    }


    // const saveToDB = async (body: ISitePages) => {
    //     setSubmitting(true);
    //     const method = props.singleData.id ? "PUT" : "POST";
    //     const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

    //     const response = await Fetch(`SitesPages${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
    //     if (response) {
    //         onHide();
    //         props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
    //         props.reloadData();
    //     }
    //     setSubmitting(false);
    // }

    const onUpload = (event: any) => {
        const file = event.files[0];
        setImageType(event.files[0].type.split("/")[1]);

        if (event.files[0].type === "image/png" || event.files[0].type === "image/jpeg" || event.files[0].type === "image/jpg") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: 'error', content: "Image File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResumeFile(file);
                setImage(true);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A Image File." });
            setImage(true);
            event.options.clear();
        }

        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "ImageF Saved", life: 3000 });

    };

    const saveToDB = async (data: any) => {
        const message = props.singleData.id != null ? "Updated Successfully" : "Added Successfully";
        const method = props.singleData.id != null ? "PUT" : "POST";
        const formData = new FormData();
        formData.append('images', resumeFile);
        formData.append('SitesPages', JSON.stringify(data));
        const params = {
            method: method,
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}SitesPages?typeoffile=${imageType}`, params);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
        } else {
            //setSaveDis(false);
        }
        setImage(false);
    }

    function onSubmit(data: ISitePages) {
       if (!image && (props.singleData.id === null || props.singleData.id === undefined)) {
            props.toast.current?.show({ severity: 'error', detail: "Please Upload Image First!", life: 3000 });
        }else {
            saveToDB(data);
        }
    }
   



    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Website Pages" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required column={2} label="Page" control={control} name="page" error={errors.page?.message} />
                <JVInput required column={2} label="Title" control={control} name="title" error={errors.title?.message} />
                <JVInput required column={2} label="Description" control={control} name="description" error={errors.description?.message} />
                <JVInput required column={2} label="Key Words" control={control} name="keywords" error={errors.keywords?.message} />
                <JVInput required column={2} label="Image Height" control={control} name="imageHeight" error={errors.imageHeight?.message} />
                <JVInput required column={2} label="Image Width" control={control} name="imageWidth" error={errors.imageWidth?.message} />
                <JVInput required column={2} label="Image Type" control={control} name="imageType" error={errors.imageType?.message} />
                <div className="card flex justify-content-center">
                    <FileUpload chooseLabel="Choose Image" mode="basic" name="image" accept="image/*" customUpload uploadHandler={onUpload} auto />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}